import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { DialogRef } from '@ngneat/dialog';
import { DataTestDirective } from '@outlaw/core';
import { IconComponent } from '@outlaw/icons';
import type { IconName } from '@outlaw/icons';

const CLOSE_ICON: IconName = 'cancel';

@Component({
  selector: 'outlaw-dialog-wrapper',
  templateUrl: './dialog-wrapper.component.html',
  styleUrls: ['./dialog-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DataTestDirective, IconComponent],
})
export class DialogWrapperComponent {
  dialogTitle = input<string>();
  closeIcon = input<IconName>(CLOSE_ICON);

  #dialogRef = inject<DialogRef>(DialogRef);

  CLOSE_ICON = CLOSE_ICON;

  onDismissClick(): void {
    this.#dialogRef.close();
  }
}
